/** Path segments for the agentic section's tabs, e.g. `agentic-access/clients`. The
 * clients tab additionally takes a `:clientId` to open a client's drawer. */
export enum AgenticPaths {
  Clients = "clients",
  EventLog = "event-log",
  Servers = "servers",
}
